import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaTypes } from './types';
import { getInstaMediaAction } from './action';
import { instaLocalIntegration } from '../../api/instagram';
import { InstaMediaType } from '../../react-pages/ServicePage/WorkshopPhotos/types';

export function* getInstaMediaWorkerSaga() {
  const res: { data: InstaMediaType[] } = yield call(instaLocalIntegration);
  yield put(getInstaMediaAction(res?.data || []));
}

export function* instaMediaWatcherSaga() {
  yield takeEvery(sagaTypes.GET_ALL_INSTA_MEDIA, getInstaMediaWorkerSaga);
}
